import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const customAttributeDeleteMutationAtom = createMutationAtomFactory(
  'settings.customAttributeDelete',
  ({ id }: { id: string }) => ({
    coreCustomAttributeDelete: {
      __args: {
        id,
      },
    },
  }),
);
